import { render } from "./DataRendered.vue?vue&type=template&id=eae5209a&scoped=true"
import script from "./DataRendered.vue?vue&type=script&lang=js"
export * from "./DataRendered.vue?vue&type=script&lang=js"

import "./DataRendered.vue?vue&type=style&index=0&id=eae5209a&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/demo-plus.centrodeglaucoma.com/darmin-plus-modular/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-eae5209a"]])

export default __exports__